module.exports = __webpack_public_path__ + "resources/img/img_gamebase_miira.4b1a277be5c05c9148ab44c4301b4382.png";